import { render, staticRenderFns } from "./ValueRow.vue?vue&type=template&id=3910f297&"
import script from "./ValueRow.vue?vue&type=script&lang=ts&"
export * from "./ValueRow.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports